import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import * as React from 'react';
import { cn } from '../../lib/utils.js';

const Textarea = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("textarea", Object.assign({ className: cn("tw:flex tw:min-h-[60px] tw:w-full tw:rounded-md tw:border tw:border-input tw:bg-transparent tw:px-3 tw:py-2 tw:text-base tw:placeholder:text-muted-foreground tw:focus-visible:outline-none tw:focus-visible:ring-1 tw:focus-visible:ring-ring tw:disabled:cursor-not-allowed tw:disabled:opacity-50 tw:md:text-sm", className), ref: ref }, props)));
});
Textarea.displayName = "Textarea";

export { Textarea };
//# sourceMappingURL=textarea.js.map
